<template>
  <div class="words-box container wrap container--translate--words align-items-stretch">
    <div
      v-for="(x, index) in words"
      class="translate--words__box col-12 col-xl-4 col-lg-4 col-md-6 col-sm-12 animation-bottom"
      :style="{animationDelay: (index / 20) + 's'}"
      :key="index"
    >

      <div class="translate--words__box--block container align-items-center">

        <div class="translate--words__box--block-number">
          <div class="ball-number">
            <span>{{ x.index }}</span>
          </div>
        </div>

        <div class="translate--words__box--block-text flex-grow-1">

          <div class="container column">
            <h2 class="word-upper">{{ x.key }}</h2>
            <p><span class="color-type">{{ !x.book ? 'Dictionary' : x.book }}</span></p>
            <p>Unit <span class="color-translate">{{ !x.unit ? 0 : x.unit }}</span></p>
          </div>

        </div>

        <div class="translate--words__box--block-info">
          <a @click="showInfo(x)">
            <i id="info" class="fas fa-info"/>
          </a>
          <a class="audio-play" @click="speak(x.key)" :disabled="playing">
            <i id="play" class="fas fa-play"/>
          </a>
        </div>

      </div>

    </div>
    <audio ref="audio"
           :src="audio"
           @playing="playing = true"
           @ended="playing = false"/>
  </div>
</template>

<script>
  import bus from './wordBus'

  export default {
    name: 'unidades',
    data () {
      return {
        voice: Object,
        playing: false
      }
    },
    computed: {
      words () {
        const arr = this.data
        const sorted = arr.sort((prev, curr) => {
          const previous = prev.key.toLowerCase()
          const current = curr.key.toLowerCase()
          if(previous < current) return -1;
          if(previous > current) return 1;
          return 0;
        })
        return sorted
      },
      audio () {
        return this.$store.getters['word/getWord']
      }
    },
    props: {
      data: {
        type: Array,
        default: () => ([])
      }
    },
    methods: {
      async speak (word) {
        this.playing = true
        const audio = this.$refs['audio']
        // await this.$store.dispatch('speech/speak', word)
        audio.pause()
        await this.$store.dispatch('word/getWord', word)
        audio.load()
        audio.play()
      },
      getBook (book) {
        if (!book) return 'Dictionary'
        else return book
      },
      getUnit (unit) {
        if (!unit) return '0'
        else return unit
      },
      showInfo (word) {
        bus.$emit('setWord', word)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .words-box {
    min-height: calc(34vh - 137px);
    max-height: 50vh;
    overflow-y: scroll;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }

  .word-upper {
    text-transform: capitalize;
  }

  .color-type {
    font-style: normal;
    font-weight: bold;
  }

  .color-translate {
    color: #50B6E5;
    font-style: normal;
  }

  .container--translate--words {
    // width: 730px;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    align-items: flex-start;
    align-content: flex-start;
    .translate--words__box {
      .translate--words__box--block {
        margin: 10px;
        box-sizing: border-box;
        border-radius: 5px;
        // background-color: #E8E8E8;
        background: linear-gradient(56.5deg, #E8E8E8 0%, #DBDBDB 100%);
        border: 1px solid transparent;
        // padding: 5px;
        transition: 0.3s;
        height: 65px;

        &:hover {
        background: linear-gradient(56.5deg, rgb(230, 230, 230) 0%, rgb(201, 201, 201) 100%);
          border: 1px solid #50B6E5;
          transform: scale(1.07);
        }
        .translate--words__box--block-number {
          height: 100%;
          .ball-number {
            height: 100%;
            width: 25px;
            color: #fff;
            border-radius: 5px 0px 0px 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #8027C7;
            background: linear-gradient(56.5deg, #8027C7 0%, #118AD3 100%);
            margin-right: 10px;
            span {
              font-weight: 300;
              font-size: 14px;
            }
          }
        }
        .translate--words__box--block-text {
          h2 {
            color: #009be2;
            font-size: 16px;
            font-weight: 300;
          }
          p {
            color: #717171;
            font-size: 14px;
            font-weight: 300;
          }
        }
        &-info {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          height: 100%;
          cursor: pointer;

          #info:nth-child(1) {
            color: white;
            background-color: orange;
            width: 30px;
            // height: 30px;
            border-radius: 0px 5px 0px 0px;
            font-size: 32px;
            padding: 8px;
            transition: all .3s ease-in;
            &:hover {
              color: #ffffff;
              background-color: rgb(255, 102, 0);
            }
          }
          #play:nth-child(1) {
            color: white;
            background-color: #4a8ef5;
            width: 30px;
            // height: 30px;
            border-radius: 0px 0px 5px 0px;
            font-size: 32px;
            padding: 9px;
            transition: all .3s ease-in;
            &:hover {
              color: #ffffff;
              background-color: #1a56af;
            }
          }

        }
      }
    }
  }

  a.audio-play:disabled {
    background: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/words/index.vue